export default __webpack_public_path__ + "static/media/bg8.391af05b.png";